import { Controller } from "@hotwired/stimulus"
import { Popover } from "bootstrap"

export default class extends Controller {
  static classes = ["hidden"]
  static targets = ["trigger", "content"]
  static values = { slug: String, title: "Are you sure?" }

  connect() {
    const clonedContent = this.contentTarget.cloneNode(true)
    this.popover = new Popover(this.triggerTarget, {
      container: "body",
      placement: "top",
      title: this.titleValue,
      html: true,
      content: clonedContent
    })

    clonedContent.classList.remove(this.hiddenClass)
  }

  disconnect() {
    this.popover.dispose()
  }

  handleHide(event) {
    if (event.detail.slug === this.slugValue) {
      this.#hide()
    }
  }

  preventDefault(event) {
    event.preventDefault()
  }

  #hide() {
    this.popover.hide()
  }
}
